<template>
  <div class="card mb-4">
    <div class="card-body">
      <h4>
        {{ "notes" | t }}
        <button
          class="btn btn-outline-primary btn-sm pull-right"
          v-if="can('write_customer_notes')"
          @click="emitCreateNoteModal"
        >
          {{ "create" | t }}
        </button>
      </h4>
      <hr />
      <div class="list-group">
        <span v-if="customer.customer_notes.length == 0"
          >Currently no notes</span
        ><a
          class="list-group-item list-group-item-action flex-column align-items-start"
          v-for="note in customer.customer_notes"
          :key="note.id"
          @click="emitOpenNoteModal(note)"
        >
          <div class="d-flex w-100 justify-content-between">
            {{ note.staff_id }}
          </div>
          <div class="mb-1">
            {{ note.note }}
            <div class="row mt-2">
              <div class="col">
                <small class="text-muted">{{
                  note.updated_at | datetime
                }}</small>
              </div>
              <div class="col text-right mb-0">
                <small class="text-muted" v-if="note.staff">{{
                  note.staff.email
                }}</small>
              </div>
            </div>
          </div></a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
  },
  methods: {
    emitCreateNoteModal() {
      this.$emit("createModal");
    },
    emitOpenNoteModal(note) {
      this.$emit("openModal", note);
    },
  },
};
</script>